import { bootstrapApplication } from '@angular/platform-browser';
import { App } from 'src/app/app';
import { appConfig } from 'src/app/app.config';

import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://e5063e5bb976ffb5a02d9a439fb40154@o4511452200697856.ingest.us.sentry.io/4511452202270720",
  sendDefaultPii: true,
  enableLogs: true,
  enableMetrics: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error", "info", "debug"] }),

  ],
  tracesSampleRate: 1.0,
  debug: true,
});


bootstrapApplication(App, appConfig).catch((err) => console.error(err));
